import SalePdfService from '../../services/sale/SalePdfService';
import TicketPdfService from '../../services/sale/TicketPdfService';
import { PreviewDocumentType } from '../../types/pdf/PreviewDocumentType';

/**
 * 🔍 Hook que obtiene el PDF (venta o ticket) según el tipo seleccionado.
 * Retorna tanto el Blob como el nombre real del archivo.
 */
export const useSalePreview = () => {
  const fetchPdfBlob = async (
    saleId: number,
    branchId: number | undefined,
    selectedType: PreviewDocumentType
  ): Promise<{ blob: Blob; fileName: string | null } | null> => {
    if (!saleId || !selectedType) return null;

    try {
      // 🎫 Si es tipo TICKET
      if (selectedType === 'TICKET' && branchId) {
        const response = await TicketPdfService.view(saleId, branchId);
        return {
          blob: response.blob,
          fileName: response.fileName || null,
        };
      }

      // 🧾 Si es documento clásico (Factura, Crédito Fiscal, etc.)
      const response = await SalePdfService.view(saleId);
      return {
        blob: response.blob,
        fileName: response.fileName || null,
      };
    } catch (error) {
      console.error('❌ Error al obtener el PDF:', error);
      return null;
    }
  };

  return { fetchPdfBlob };
};
